import _asyncToGenerator from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import axios from 'axios';
import { path, pathOr } from 'ramda';
import { urls } from '../config';
import { SafeApiError } from '../utils/errors';
import withAxios from '../utils/with-axios';
import v3Generic from './v3-generic';
var HTTP_TOO_LARGE = 413;
var _v3Generic = v3Generic('printables'),
  create = _v3Generic.create,
  single = _v3Generic.single,
  update = _v3Generic.update;
var byTransactionId = function byTransactionId(axios, transactionId) {
  return axios.get(urls.apiV3("/printables/transactions/".concat(transactionId))).then(path(['data', 'data']));
};
var generatePdf = function generatePdf(axios, transactionId) {
  return axios.post(urls.apiV3('/printables/pdfs'), {
    transactionId: transactionId
  }).then(path(['data', 'data']));
};
var getPdfStatus = function getPdfStatus(axios, _ref) {
  var printableId = _ref.printableId,
    operationId = _ref.operationId;
  return axios.get(urls.apiV3("/printables/".concat(printableId, "/pdfs/").concat(operationId))).then(path(['data', 'data']));
};

/**
 *
 * Accepted content types are ["image/png", "image/jpg", "image/jpeg", "image/svg+xml"]
 * Max file size is 200000 bytes, AWS checks the file put matches what was given in this post request
 *
 * @param {axios} axios
 * @param {File} file
 */
var uploadLogo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(apiAxios, file) {
    var _yield$apiAxios$post, _yield$apiAxios$post$, signedUrl, key, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return apiAxios.post(urls.apiV3('/printables/logos/presigned-urls'), {
            contentType: file.type,
            contentLength: file.size
          });
        case 1:
          _yield$apiAxios$post = _context.v;
          _yield$apiAxios$post$ = _yield$apiAxios$post.data.data;
          signedUrl = _yield$apiAxios$post$.signedUrl;
          key = _yield$apiAxios$post$.key;
          _context.n = 2;
          return axios.put(signedUrl, file, {
            headers: {
              contentType: file.type,
              contentLength: file.size
            }
          });
        case 2:
          return _context.a(2, key);
        case 3:
          _context.p = 3;
          _t = _context.v;
          if (!(_t.isAxiosError && pathOr(null, ['response', 'status'], _t) === HTTP_TOO_LARGE)) {
            _context.n = 4;
            break;
          }
          throw new SafeApiError('File is too large', _t.message, null, HTTP_TOO_LARGE, _t.response, _t);
        case 4:
          throw _t;
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[0, 3]]);
  }));
  return function uploadLogo(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export default {
  uploadLogo: withAxios(uploadLogo),
  byTransactionId: withAxios(byTransactionId),
  generatePdf: withAxios(generatePdf),
  getPdfStatus: withAxios(getPdfStatus),
  create: create,
  single: single,
  update: update
};